'use client';

import { ColumnFiltersState } from '@tanstack/react-table';
import { action, makeObservable, observable } from 'mobx';

class FilterPersistenceStore {
  filtersMap: Record<string, ColumnFiltersState> = {};

  constructor() {
    makeObservable(this, {
      filtersMap: observable,
      set: action.bound,
    });
  }

  set(pathname: string, filters: ColumnFiltersState) {
    this.filtersMap[pathname] = filters;
  }

  get(pathname: string): ColumnFiltersState | null {
    return this.filtersMap[pathname] ?? null;
  }
}

export const filterPersistenceStore = new FilterPersistenceStore();
